//IMPORTING COLORS
import { useEffect, useState } from "react";
import authService from "../../services/authService";
import obituaryService from "../../services/obituaryService";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import LoadingContainerLarge from "../LoadingContainerLarge/index.js";
import ErrorContainer from "../ErrorContainer/index.js";
import NoDataContainer from "../NoDataContainer/index.js";
import { LiaDoveSolid } from "react-icons/lia";
import Button from "react-bootstrap/Button";
import { FaRegStar } from "react-icons/fa";
import { LiaPlaceOfWorshipSolid } from "react-icons/lia";
import { TbBuildingBank } from "react-icons/tb";
import { FiCalendar } from "react-icons/fi";
import { IoMdTime } from "react-icons/io";
import { PiFlowerTulipThin } from "react-icons/pi";
import { PiHandsPraying } from "react-icons/pi";
import CandleModal from "../CandleModal";
import LogoFuneralDistancia from "../../assets/images/logo-funeral-distancia.png";
import "./Obituary.css";

export default function Obituary(props) {
  const [modalShow, setModalShow] = useState(false);
  const [obituaryData, setObituaryData] = useState();
  const [dataContainer, setDataContainer] = useState(null);
  const [falecidoName, setFalecidoName] = useState(null);

  const startDay = new Date();
  startDay.setDate(startDay.getDate() - 1);
  const currentStartDay = startDay.toJSON().slice(0, 10);

  const endDay = new Date();
  const currentEndDay = endDay.toJSON().slice(0, 10);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setDataContainer(LoadingContainerLarge);

        const tokenData = {
          NomeUsuario: process.env.REACT_APP_INVITA_API_USER,
          Senha: process.env.REACT_APP_INVITA_API_PASS,
        };

        authService
          .post(process.env.REACT_APP_INVITA_API_URL, tokenData)
          .then((response) => {
            const token = response.data;
            obituaryService
              .get(`/?dataInicio=${currentStartDay}&dataFim=${currentEndDay}`, {
                headers: {
                  Authorization: `Bearer ${token.token}`,
                },
              })
              .then((response) => {
                setObituaryData(
                  response.data.sort(
                    (a, b) =>
                      a.sepultamentoData.localeCompare(b.sepultamentoData) ||
                      a.sepultamentoHora.localeCompare(b.sepultamentoHora),
                  ),
                );
                setDataContainer(obituaryData);
              })
              .catch((err) => {
                console.error("API Funeral Invita" + err);
                setDataContainer(
                  <NoDataContainer
                    icon={<PiHandsPraying className="no-data-container-icon" />}
                    message="Sem registros no momento"
                  />,
                );
              });
          })
          .catch((err) => {
            console.error("Ocorreu um erro API " + err);
            setDataContainer(ErrorContainer);
          });
      } catch (err) {
        console.error("Ocorreu um erro ao buscar os dados" + err);
      }
    };
    fetchData();
  }, []);

  return (
    <Container fluid className="obituary-bg">
      <Container fluid className="obituary-overlay">
        <Container>
          <Row>
            <Col className="obituary-first-col">
              <h2
                style={{ color: props.titleColor, fontSize: props.titleSize }}
              >
                <LiaDoveSolid
                  style={{ color: props.iconColor }}
                  className="obituary-icon"
                />
                OBITUÁRIO
              </h2>
            </Col>
          </Row>
          <Row>
            <Col className="obituary-second-col">
              <p style={{ color: props.textColor, fontSize: props.textSize }}>
                Nossos sentimentos às famílias enlutadas.
              </p>
            </Col>
          </Row>
          <Container className="obituary-container">
            {obituaryData?.map((funeral, id) =>
              funeral.divulgarRedeSocial === true &&
              funeral.sepultamentoData !== null &&
              funeral.sepultamentoHora !== null &&
              (funeral.localVelorios.length > 0 ||
                funeral.localExternos.length > 0) ? (
                <Row
                  key={id}
                  style={{ background: props.white }}
                  className="obituary-card"
                >
                  <Col lg="2" className="obituary-third-col">
                    {funeral.fotoFalecido ? (
                      <img
                        src={
                          "data:image/jpeg;base64," +
                          funeral.fotoFalecido.content
                        }
                        alt="Foto do Falecido(a)"
                        className="obituary-img"
                      />
                    ) : (
                      <div className="obituary-no-img">
                        <PiFlowerTulipThin className="obituary-no-img-icon" />
                      </div>
                    )}
                  </Col>
                  <Col lg="8" className="obituary-fourth-col">
                    <h3
                      style={{
                        color: props.titleColor,
                        fontSize: props.subTitleSize,
                      }}
                    >
                      {funeral.falecidoNome.toUpperCase()}
                    </h3>
                    <div className="obituary-row-container">
                      <div>
                        <p
                          style={{
                            color: props.textColor,
                            fontSize: props.subTextSize,
                          }}
                        >
                          Nascimento
                        </p>
                        <h4
                          style={{
                            color: props.textColor,
                            fontSize: props.textSize,
                          }}
                        >
                          <FaRegStar
                            style={{ color: props.iconColor }}
                            className="obituary-card-icon"
                          />{" "}
                          {funeral.falecidoDataNascimento}
                        </h4>
                      </div>
                      <div id="spacing-block">
                        <p
                          style={{
                            color: props.textColor,
                            fontSize: props.subTextSize,
                          }}
                        >
                          Falecimento
                        </p>
                        <h4
                          style={{
                            color: props.textColor,
                            fontSize: props.textSize,
                          }}
                        >
                          <LiaDoveSolid
                            style={{ color: props.iconColor }}
                            className="obituary-card-icon"
                          />{" "}
                          {funeral.falecimentoData}
                        </h4>
                      </div>
                    </div>
                    <div className="obituary-second-row-container">
                      <div>
                        <div>
                          <p
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            Local do Velório
                          </p>
                          <h5
                            className="obituary-row-container"
                            style={{
                              color: props.textColor,
                              fontSize: props.textSize,
                            }}
                          >
                            <LiaPlaceOfWorshipSolid
                              style={{ color: props.iconColor }}
                              id="obituary-card-icon"
                            />{" "}
                            {funeral.localVelorios.length > 0
                              ? funeral.localVelorios.map((sala, subId) => (
                                  <div key={subId}>{sala.sala}</div>
                                ))
                              : funeral.localExternos.map((sala, subId) => (
                                  <div key={subId}>
                                    {sala.descricaoTipoLocal !== ""
                                      ? sala.descricaoTipoLocal
                                      : sala.endereco +
                                        " " +
                                        sala.complemento +
                                        " - " +
                                        sala.cidade}
                                  </div>
                                ))}
                          </h5>
                        </div>
                        <div className="obituary-btn-container">
                          {funeral.localVelorios.length > 0
                            ? funeral.localVelorios.map((endereco, subId) => (
                                <CustomButton
                                  key={subId}
                                  className="secondary-btn"
                                  variant="secondary"
                                  href={`https://www.google.com/maps/search/?api=1&query=${endereco.logradouro}+${endereco.numero}+${endereco.bairro}+${endereco.cidade}`}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  content="LOCALIZAÇÃO VELÓRIO"
                                  backgroundColor={props.white}
                                  fontFamily="Unageo-Semibold"
                                  fontColor={props.secondaryBtnColor}
                                  fontSize={16}
                                  width={260}
                                  borderColor={props.secondaryBtnColor}
                                  disabled={false}
                                  googleBtnName="Botão 'LOCALIZAÇÃO VELÓRIO' obituário"
                                />
                              ))
                            : funeral.localExternos.map((endereco, subId) => (
                                <CustomButton
                                  key={subId}
                                  className="secondary-btn"
                                  variant="secondary"
                                  href={`https://www.google.com/maps/search/?api=1&query=${endereco.endereco}+${endereco.numero}+${endereco.bairro}+${endereco.cidade}`}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  content="LOCALIZAÇÃO VELÓRIO"
                                  backgroundColor={props.white}
                                  fontFamily="Unageo-Semibold"
                                  fontColor={props.secondaryBtnColor}
                                  fontSize={16}
                                  width={260}
                                  borderColor={props.secondaryBtnColor}
                                  disabled={false}
                                  googleBtnName="Botão 'LOCALIZAÇÃO VELÓRIO' obituário"
                                />
                              ))}
                        </div>
                      </div>
                      <div id="spacing-block">
                        <p
                          style={{
                            color: props.textColor,
                            fontSize: props.subTextSize,
                          }}
                        >
                          Data do Encerramento
                        </p>
                        <h4
                          style={{
                            color: props.textColor,
                            fontSize: props.textSize,
                          }}
                        >
                          <FiCalendar
                            style={{ color: props.iconColor }}
                            className="obituary-card-icon"
                          />{" "}
                          {funeral.sepultamentoData}
                        </h4>
                      </div>
                      <div id="spacing-block">
                        <p
                          style={{
                            color: props.textColor,
                            fontSize: props.subTextSize,
                          }}
                        >
                          Horário do Encerramento
                        </p>
                        <h4
                          style={{
                            color: props.textColor,
                            fontSize: props.textSize,
                          }}
                        >
                          <IoMdTime
                            style={{ color: props.iconColor }}
                            className="obituary-card-icon"
                          />{" "}
                          {funeral.sepultamentoHora.slice(0, 5)}
                        </h4>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div>
                          <p
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            Local do Sepultamento
                          </p>
                          <h5
                            style={{
                              color: props.textColor,
                              fontSize: props.textSize,
                            }}
                          >
                            <TbBuildingBank
                              style={{ color: props.iconColor }}
                              className="obituary-card-icon"
                            />{" "}
                            {funeral.cemiterioNome}
                          </h5>
                          <div className="obituary-btn-container">
                            <CustomButton
                              className="secondary-btn"
                              variant="secondary"
                              href={`https://www.google.com/maps/search/?api=1&query=${funeral.cemiterioEndereco}+${funeral.cemiterioEnderecoNumero}+${funeral.cemiterioEnderecoBairro}+${funeral.cemiterioEnderecoCidade}+${funeral.cemiterioEnderecoCep}`}
                              rel="noopener noreferrer"
                              target="_blank"
                              content="LOCALIZAÇÃO SEPULTAMENTO"
                              backgroundColor={props.white}
                              fontFamily="Unageo-Semibold"
                              fontColor={props.secondaryBtnColor}
                              fontSize={16}
                              width={300}
                              borderColor={props.secondaryBtnColor}
                              disabled={false}
                              googleBtnName="Botão 'LOCALIZAÇÃO SEPULTAMENTO' obituário"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg="2" className="obituary-fifth-col">
                    <CustomButton
                      className="primary-btn-obituary"
                      variant="primary"
                      href={
                        funeral.linkVelorioOnline
                          ? funeral.linkVelorioOnline
                          : ""
                      }
                      rel="noopener noreferrer"
                      target="_blank"
                      icon=""
                      content="Deixe um recado"
                      backgroundColor={props.primaryBtnColor}
                      fontFamily="Monotype-Corsiva-Regular"
                      fontColor={props.white}
                      fontSize={18}
                      width="90%"
                      borderColor={props.primaryBtnColor}
                      disabled={funeral.linkVelorioOnline ? false : true}
                      googleBtnName="Botão 'Deixe um recado' obituário"
                    />
                    <Button
                      className="primary-btn-obituary"
                      style={{
                        backgroundColor: props.primaryBtnColor,
                        fontFamily: "Monotype-Corsiva-Regular",
                        fontColor: props.white,
                        fontSize: "18px",
                        width: "90%",
                        borderColor: props.primaryBtnColor,
                      }}
                      onClick={() =>
                        setModalShow(true) +
                        setFalecidoName(funeral.falecidoNome)
                      }
                    >
                      Acenda uma vela
                    </Button>
                  </Col>
                </Row>
              ) : (
                ""
              ),
            )}
          </Container>
          <Container>
            {obituaryData &&
              obituaryData.every((funeral) => !funeral.divulgarRedeSocial) && (
                <NoDataContainer
                  icon={<PiHandsPraying className="no-data-container-icon" />}
                  message="Sem registros no momento"
                />
              )}
          </Container>
        </Container>
        <Container className="obituary-container">{dataContainer}</Container>
        {props.funeralDistanciaCall ? (
          <Container>
            <CandleModal
              show={modalShow}
              onHide={() => setModalShow(false)}
              centered
              size="lg"
              falecido={falecidoName}
              btncolor={props.primaryBtnColor}
            />
            <Row>
              <Col className="obituary-sixth-col">
                <img
                  src={LogoFuneralDistancia}
                  alt="logo funeral a distância"
                />
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="/funeral-a-distancia/"
                  rel="noopener noreferrer"
                  icon=""
                  content="ACESSE AQUI"
                  backgroundColor={props.primaryBtnColor}
                  fontFamily="Unageo-Bold"
                  fontColor={props.white}
                  fontSize={20}
                  width={240}
                  borderColor={props.primaryBtnColor}
                  disabled={false}
                  googleBtnName="Botão 'ACESSE AQUI' Funeral a Distância"
                />
              </Col>
            </Row>
          </Container>
        ) : (
          ""
        )}
      </Container>
    </Container>
  );
}
